import React from "react";

// navigation
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { register_user } from "../../../service/api/auth";
import { IRegister, IRegisterError } from "../../../store/@types/auth";

const useRegister = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [token, tokenSet] = React.useState("");
  const [data, dataSet] = React.useState<IRegister>({
    name: "",
    phone_number: "",
    accepted_terms: false,
    email: "",
    password: "",
    password_confirmation: "",
    country_id: 0,
    client: "web",
  });
  const [error, errorSet] = React.useState<IRegisterError>({
    name: "",
    phone_number: "",
    accepted_terms: "",
    email: "",
    password: "",
    password_confirmation: "",
    country_id: "",
  });

  const validate = () => {
    let error = false;
    if (!data.name) {
      error = true;
      errorSet((prev) => ({ ...prev, name: "warning" }));
    }
    if (!data.phone_number) {
      error = true;
      errorSet((prev) => ({ ...prev, phone_number: "warning" }));
    }
    if (!data.email) {
      error = true;
      errorSet((prev) => ({ ...prev, email: "warning" }));
    }
    if (!data.password) {
      error = true;
      errorSet((prev) => ({ ...prev, password: "warning" }));
    }
    if (data.password !== data.password_confirmation) {
      error = true;
      errorSet((prev) => ({ ...prev, password_confirmation: "warning" }));
    }
    if (!data.accepted_terms) {
      error = true;
      errorSet((prev) => ({ ...prev, accepted_terms: "warning" }));
    }

    if (!data.country_id) {
      error = true;
      errorSet((prev) => ({ ...prev, country_id: "warning" }));
    }

    return error ? false : true;
  };

  const onSubmit = async () => {
    // e.preventDefault();

    if (validate()) await register_user(data, dispatch, navigate);
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    errorSet((prev) => ({ ...prev, [name]: "" }));
    dataSet((prev) => ({ ...prev, [name]: value }));
  };

  return {
    data,
    token,
    tokenSet,
    dataSet,
    error,
    errorSet,
    onSubmit,
    onChange,
  };
};

export default useRegister;
